// extracted by mini-css-extract-plugin
export default {"reference-id":"reference-id_reference-id__dadHW"};